import React, { Fragment } from 'react'

import TextTruncate from 'react-text-truncate'

import {
  ModelCardTitle,
  BreadCrumbs,
  classnames,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  array, bool, string, oneOf,
} from 'prop-types'

import Categories from 'Pods/Blog/Components/Categories/Categories'
import { imageUrlToAvoid } from 'Pods/Blog/Static/Constants'
import { headingsMap } from 'Pods/Blog/Static/HeadingsMap'

import { getDate } from 'Utils/FormatDate'
import { EMPTY_ARRAY } from 'Utils/stableDefaults'

function FeaturedPost({
  isSmall = false,
  isPostPage = false,
  categories = EMPTY_ARRAY,
  publishDate = '',
  image = '',
  newImage = '',
  link = '',
  title,
  slug,
  wrapped = false,
  withBreadcrumbs = false,
  titleStyle,
  titleComponent,
  showFullTitle = false,
}) {
  function renderTitle() {
    return (
      <ModelCardTitle
        variant={titleStyle}
        component={titleComponent}
        customClass={classnames(
          'blog-post__text-title',
          isSmall && 'blog-post__text-title--small blog-post__text-title--three-lines '
        )}
      >
        {showFullTitle ? (
          <span>{title}</span>
        ) : (
          <TextTruncate text={title} truncateText="..." line={3} />
        )}
      </ModelCardTitle>
    )
  }

  function renderImage() {
    const hasNewImage = !!newImage && !newImage.includes(imageUrlToAvoid)
    const imageSrc = hasNewImage ? newImage : image

    if (!imageSrc) {
      return null
    }

    return (
      <img
        src={imageSrc}
        className={classnames(
          'cgt-model-card__image new-blog-post-preview',
          !hasNewImage && 'old-blog-post-preview'
        )}
        alt="Featured post"
      />
    )
  }

  const haveCategories = categories && categories.length > 0
  const firstCategory = haveCategories ? categories[0] : {}
  const { title: categoryTitle, slug: categorySlug } = firstCategory

  const breadCrumbsData = [{ name: 'Blog', url: '/blog' }]

  if (categoryTitle && categorySlug) {
    breadCrumbsData.push({ name: categoryTitle, url: `/blog/${categorySlug}` })
  }

  if (title && slug) {
    breadCrumbsData.push({ name: title })
  }

  function renderContent() {
    return (
      <Fragment>
        <div className={classnames('col-12', isSmall ? 'col-md-6' : 'col-sm-6')}>
          <div
            className={classnames(
              'blog-post-content',
              isSmall && 'blog-post-content--small'
            )}
          >
            <div>
              {withBreadcrumbs && <BreadCrumbs data={breadCrumbsData} className="new-blog-breadcrumb-text" />}
              {publishDate && (
                <div className="cgt-legacy-text-caption cgt-legacy-color-typography-disabled">
                  {getDate(publishDate)}
                </div>
              )}

              {link ? (
                <a href={link} className="blog-post-link">
                  {renderTitle()}
                </a>
              ) : (
                renderTitle()
              )}
            </div>

            <Categories list={categories} />
          </div>
        </div>

        <div
          className={classnames(
            'blog-post__content',
            isPostPage && 'blog-post-image-container',
            isSmall ? 'col-md-6' : 'col-sm-6'
          )}
        >
          <div className="blog-post-image-wrapper">
            <div
              className={classnames(
                'blog-post-image',
                'cgt-legacy-back-color-brand-primary-10',
                isSmall && 'blog-post-image--small',
                !image && 'blog-post-image--empty'
              )}
            >
              {link ? (
                <a href={link} className="blog-post-image-link">
                  {renderImage()}
                </a>
              ) : (
                renderImage()
              )}
            </div>
          </div>
        </div>
      </Fragment>
    )
  }

  if (wrapped) return <div className="post-wrap row">{renderContent()}</div>

  return renderContent()
}

FeaturedPost.propTypes = {
  isSmall: bool,
  isPostPage: bool,
  categories: array,
  publishDate: string,
  image: string,
  newImage: string,
  wrapped: bool,
  link: string,
  title: string.isRequired,
  slug: string.isRequired,
  withBreadcrumbs: bool,
  titleComponent: oneOf(headingsMap).isRequired,
  titleStyle: oneOf(headingsMap).isRequired,
  showFullTitle: bool,
}

export default FeaturedPost
